import React, { useState } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import Modal, {
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter } from '@qality/common-components';
import { FlagService, FolderService } from '@qality/common-service';

import { DeleteFolderProps } from '../TestCaseRepositoryModalsProvider/TestCaseRepositoryModalsProvider';
import { ALL_TEST_CASES } from '../TestCaseRepositoryPage.const';
import { ModalTextStyled } from './DeleteFolderModal.styled';

type Props = {
  onClose: () => void;
  onDeleteFolder: () => void;
  deleteFolderProps: DeleteFolderProps;
};

const DESCRIPTION_TEXT = `All subfolders will be permanently deleted and all test cases stored in those folders will still be available in the "${ALL_TEST_CASES}" tab`;

export default function DeleteFolderModal({
  onClose,
  onDeleteFolder,
  deleteFolderProps: { folder },
}: Props): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteFolder = async () => {
    try {
      setIsLoading(true);
      FolderService.deleteFolder(folder.id);

      onDeleteFolder();

      FlagService.createSuccessFlag('Success', `Successfully deleted folder.`);
    } catch (error) {
      FlagService.createErrorFlag(
        'Error',
        `We could not delete selected folder. Please try again. If the problem persists, feel free to contact our support.`
      );
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  return (
    <ModalTransition>
      <Modal
        onClose={onClose}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={true}
        shouldScrollInViewport
        width={400}
      >
        <ModalHeader>
          <ModalTitle appearance='danger'>Delete folder</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <ModalTextStyled>{DESCRIPTION_TEXT} </ModalTextStyled>
        </ModalBody>
        <ModalFooter>
          <Button appearance='subtle' onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            isLoading={isLoading}
            appearance='danger'
            onClick={() => handleDeleteFolder()}
          >
            Delete folder
          </LoadingButton>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
}
